import { render, staticRenderFns } from "./AtualizacaoProcuracao.vue?vue&type=template&id=17238c14&"
import script from "./AtualizacaoProcuracao.vue?vue&type=script&lang=js&"
export * from "./AtualizacaoProcuracao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports